var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-user-icon",style:(_vm.cssStyle)},[(_vm.profilePhotoLink)?_c('img',{attrs:{"src":_vm.profilePhotoLink}}):_c('span',[_vm._v(_vm._s(_vm.$t('settings.photo')))])])}
var staticRenderFns = []

export { render, staticRenderFns }